import { DEFAULT_CURRENCY } from '@vy/types';
import { withDefault } from '@vy/utils';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import type { InvoiceFormInput } from '../CreateInvoiceForm/create-invoice-form-types/invoice-form-input';
import { CreateInvoicePageFixedChargesTabContent } from './create-invoice-page-tabs-components/CreateInvoicePageFixedChargesTabContent';
import { Stack } from '@mui/material';

export const CreateInvoicePageTabs: React.FC = () => {
  const { watch } = useFormContext<InvoiceFormInput>();

  return (
    <Stack sx={{
      padding: 2
    }}>
      <CreateInvoicePageFixedChargesTabContent
        fixedProducts={[...withDefault(watch('fixedProducts'), [])]}
        currency={withDefault(watch('settings.currency'), DEFAULT_CURRENCY)}
      />
    </Stack>
  );
};
